import { restaurant } from "../data/menu";

const DAY_INDEX_FR = {
  Dimanche: 0,
  Lundi: 1,
  Mardi: 2,
  Mercredi: 3,
  Jeudi: 4,
  Vendredi: 5,
  Samedi: 6,
};

export default function Horaires() {
  const today = new Date().getDay();

  return (
    <section
      id="horaires"
      data-testid="hours-section"
      className="relative py-24 lg:py-32 bg-[#fdfbf7] border-y border-[#e5e0d5]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <p className="text-xs uppercase tracking-[0.32em] text-[#c23b22] mb-4">
            <i className="fa-regular fa-clock mr-2" />
            Horaires d'ouverture
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#1a1a1a] leading-tight">
            Tous les soirs,
            <br />
            <em className="italic text-[#2d4a22]">sauf le mardi.</em>
          </h2>
          <p className="mt-6 text-[#5c5c5c] text-base leading-relaxed max-w-md">
            Nous ouvrons en service du soir uniquement. Pour les soirées
            chargées, n'hésitez pas à réserver votre pizza par téléphone.
          </p>
          <a
            href={`tel:${restaurant.phoneRaw}`}
            data-testid="hours-phone-cta"
            className="mt-8 inline-flex items-center gap-3 bg-[#c23b22] hover:bg-[#a12e1a] text-white px-7 py-3.5 rounded-full font-semibold transition-colors"
          >
            <i className="fa-solid fa-phone" />
            Appeler maintenant
          </a>
        </div>

        <div className="bg-white border border-[#e5e0d5] rounded-2xl p-6 sm:p-10 shadow-sm">
          <ul className="divide-y divide-[#e5e0d5]">
            {restaurant.hours.map((h) => {
              const isToday = DAY_INDEX_FR[h.day] === today;
              const closed = h.value === "Fermé";
              return (
                <li
                  key={h.day}
                  data-testid={`hours-row-${h.day.toLowerCase()}`}
                  className={`flex items-center justify-between py-4 ${
                    isToday ? "bg-[#f6efe2] -mx-6 sm:-mx-10 px-6 sm:px-10 rounded" : ""
                  }`}
                >
                  <span
                    className={`font-serif text-lg ${
                      isToday ? "text-[#c23b22]" : "text-[#1a1a1a]"
                    }`}
                  >
                    {h.day}
                    {isToday && (
                      <span className="ml-3 text-[10px] uppercase tracking-[0.2em] bg-[#c23b22] text-white px-2 py-0.5 rounded-full align-middle">
                        Aujourd'hui
                      </span>
                    )}
                  </span>
                  <span
                    className={`text-sm sm:text-base font-medium ${
                      closed ? "text-[#5c5c5c] italic" : "text-[#1a1a1a]"
                    }`}
                  >
                    {h.value}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}
